<!-- Lint doesn't like v-for without a key and doesn't like key on template -->
<!-- eslint-disable vue/valid-v-for -->
<template>
  <v-row row dense class="py-2 pl-2 pr-0 mx-0">
    <v-col class="col-12">
      <v-container fluid grid-list-xs class="pa-0">
        <v-row row wrap dense class="center-infinite-loading-spinner">
          <div class="content-container">
            <v-col v-for="(item, index) in items" x12 class="mb-2 pa-0 col-12">
              <CalendarEventsTimelineItem
                :key="index"
                :item="item"
                @show-event="showEvent"
              />
            </v-col>
            <infinite-loading
              v-if="heightPixels && infiniteLoadReset"
              ref="InfiniteLoading"
              @infinite="infiniteHandler"
              :distance="heightPixels"
            >
              <div slot="spinner">
                <Loader text=""></Loader>
              </div>
            </infinite-loading>
          </div>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const EMITTED_ACTIONS = {
  GET_DATA: "get-data",
  SHOW_EVENT: "show-event",
};

export default {
  name: "CalendarEventsTimeline",
  components: {
    CalendarEventsTimelineItem: () =>
      import("@/components/calendarEvents/CalendarEventsTimelineItem"),
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    items: {
      type: Array,
    },
    page: {
      type: Number,
      required: true,
    },
    heightPixels: {
      type: Number,
    },
    scrollToTop: {
      type: String,
    },
    infiniteLoadReset: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    infiniteHandler($state) {
      this.$emit(EMITTED_ACTIONS.GET_DATA, this.page + 1, $state);
    },
    showEvent(event) {
      this.$emit(EMITTED_ACTIONS.SHOW_EVENT, event);
    },
  },
  watch: {
    infiniteLoadReset() {
      this.$refs.InfiniteLoading?.stateChanger.reset();
    },
    scrollToTop() {
      //TODO not implementing this until the layout is redone.
      // Not worth it when I don't know what div is ultimately going to scroll
    },
  },
};
</script>

<style scoped>
.dateSection {
  border-style: solid;
  border-color: #d8d8d8;
  border-width: 2px;
  background: white;
  border-radius: 4px;
  color: #1c1c1c;
  text-align: left;
  width: max-content;
  position: relative;
  left: -89px;
}
.content-container {
  width: 100% !important;
  padding: 2px 10px 0 0;
  margin-bottom: 20px;
}
.center-infinite-loading-spinner {
  margin: 0 auto;
  margin-bottom: 15px;
}
</style>
